import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IXeroTokenRecord } from '../interfaces/xero-token-record';
import { IXeroTokenInfo } from '../interfaces/xero-token-info';

@Injectable({ providedIn: 'root' })
export class XeroSettingsService {
  constructor(public http: HttpClient) {}

  public FetchAllTokens(): Promise<IXeroTokenInfo> {
    return this.http.get<IXeroTokenInfo>('api/xero/FetchAllTokens').toPromise();
  }
}
